export const QrTargetType = {
  LOT: 'LOT',
  TEMPERATURE_EQUIPMENT: 'TEMPERATURE_EQUIPMENT',
  OIL_FRYER: 'OIL_FRYER',
  CLEANING_AREA: 'CLEANING_AREA',
  PEST_CONTROL_POINT: 'PEST_CONTROL_POINT',
  METAL_DETECTOR: 'METAL_DETECTOR',
} as const;

export type QrTargetType = (typeof QrTargetType)[keyof typeof QrTargetType];

/// Bindable target types — excludes LOT, since lots are bound through their dedicated endpoint.
export const BindableQrTargetType = {
  TEMPERATURE_EQUIPMENT: QrTargetType.TEMPERATURE_EQUIPMENT,
  OIL_FRYER: QrTargetType.OIL_FRYER,
  CLEANING_AREA: QrTargetType.CLEANING_AREA,
  PEST_CONTROL_POINT: QrTargetType.PEST_CONTROL_POINT,
  METAL_DETECTOR: QrTargetType.METAL_DETECTOR,
} as const;

export type BindableQrTargetType = (typeof BindableQrTargetType)[keyof typeof BindableQrTargetType];
